import { makeStyles } from '@mui/styles'
import Colors from 'utils/Colors'

const styles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    height: '100vh',
    overflow: 'hidden',
    // maxHeight: '100vh',
    background:
      'url("/assets/images/backgrounds/background_image.webp") no-repeat ',
    backgroundSize: 'cover',
  },

  header: {
    backgroundColor: Colors.loginPrimaryColor,
    width: '100%',
    height: 'fit-content',
    padding: '1.5rem',
    zIndex: 1000,
    boxShadow: '1px 1px 3px 1px rgba(0,0,0,.25)',

    '@media (min-width: 900px)': {
      display: 'none',
    },
  },

  sideTriangle: {
    zIndex: 0,
    position: 'absolute',
    left: 0,
    bottom: 0,
    width: '0',
    height: '0',
    borderLeft: `52rem solid ${Colors.loginPrimaryColor}`,
    borderTop: `80vh solid transparent`,

    '@media (max-width: 1028px)': {
      borderLeft: `40rem solid ${Colors.loginPrimaryColor}`,
    },

    '@media (max-width: 900px)': {
      display: 'none',
    },
  },

  accessMessage: {
    marginBottom: 50,

    '& > h1': {
      fontSize: 50,
    },

    '& > p': {
      fontSize: 18,
    },

    '@media (max-width: 900px)': {
      display: 'none',
    },
  },

  aside: {
    display: 'flex',
    flexDirection: 'column',
    width: '30%',
    justifyContent: 'space-between',
    padding: 40,
    color: theme.palette.primary.lighter,
    zIndex: 1,
    '@media (max-width: 900px)': {
      display: 'none',
    },
  },

  logo: {
    width: 300,

    [theme.breakpoints.down('lg')]: {
      width: 230,
    },
    '@media (max-width: 900px)': {
      width: 140,
    },
  },

  title: {
    color: Colors.titleColor,
    fontSize: 30,
    '@media (max-width: 900px)': {
      padding: '4rem 0',
    },

    '@media (max-width: 390px)': {
      fontSize: 26,
    },
    
    '@media (max-width: 360px)': {
      fontSize: 22,
    },
  },

  main: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: '100%',
    width: 'fit-content',
    position: 'absolute',
    top: 0,
    right: 0,
    padding: '60px 100px',
    backgroundColor: `${Colors.transparentFormColor}`,
    backdropFilter: 'blur(3px)',
    '@media (max-width: 900px)': {
      width: '100%',
      justifyContent: 'flex-start',
      backgroundColor: `${Colors.transparentOpaqueFormColor}`,
      backdropFilter: 'blur(7px)',
    },
  },

  link: {
    '& a': {
      textDecoration: 'none',
      color: Colors.loginPrimaryColor,
      '&:visited ': {
        color: Colors.loginPrimaryColor,
      },
      '&:hover': {
        textDecoration: 'underline',
      },
      '&:active': {
        textDecoration: 'underline',
      },
    },
  },

  formContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  inputsContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  textField: {
    minWidth: 300,
    maxWidth: 'calc(100vw - 5rem)',
    width: '100%',
    marginBottom: 30,
    '& input': {
      color: `${Colors.primaryTextColor}`,
      padding: '6px',
    },
    '& input:-webkit-autofill ': {
      '-webkit-background-clip': 'text',
    },
    '& label': {
      color: `${Colors.primaryTextColor}`,
    },
    '@media (max-width: 900px)': {
      width: '600px',
    },
  },

  button: {
    width: 300,
    height: 50,
    borderRadius: 30,
    marginTop: 50,
    marginBottom: 20,
    transition: 'all 200ms ease-in-out',
    backgroundColor: `${Colors.loginPrimaryColor}`,
    '&:hover': {
      backgroundColor: `${Colors.loginDarkenPrimaryColor}`,
    },
  },
  buttonContainer: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },

  progress: {
    height: '25px !important',
    margin: theme.spacing(1),
    width: '25px !important',
  },
  noDisplay: {
    display: 'none',
  },
}))

export default styles
